import { render, staticRenderFns } from "./upstreampaymentDetail.vue?vue&type=template&id=89feb9a8&scoped=true"
import script from "./upstreampaymentDetail.vue?vue&type=script&lang=js"
export * from "./upstreampaymentDetail.vue?vue&type=script&lang=js"
import style0 from "./upstreampaymentDetail.vue?vue&type=style&index=0&id=89feb9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89feb9a8",
  null
  
)

export default component.exports